import { isMicrosoftGuid } from '../../../../util/employeeLicenses.util'

export const TAB_KEYS = {
  USER_PROPERTIES: 'userproperties',
  GROUPS: 'groups',
  LICENSES: 'licenses',
}

// Tab configuration
export const TABS = [
  { key: TAB_KEYS.USER_PROPERTIES, label: 'User Properties' },
  { key: TAB_KEYS.GROUPS, label: 'Groups' },
  { key: TAB_KEYS.LICENSES, label: 'Licenses' },
]

export const getEditModalTabs = ({ isIntegrated = false, isGws = false } = {}) => {
  if (!isIntegrated) {
    return TABS.filter((tab) => tab.key === TAB_KEYS.USER_PROPERTIES)
  }
  if (isGws) {
    return TABS.filter((tab) => tab.key !== TAB_KEYS.GROUPS)
  }
  return TABS
}

export const buildGwsLicenseCatalog = (employees = []) => {
  const licenseMap = new Map()

  employees.forEach((employee) => {
    const licenses = employee?.licenseType || []
    licenses.forEach((license) => {
      if (license?.id && !isMicrosoftGuid(license.id) && !licenseMap.has(license.id)) {
        licenseMap.set(license.id, {
          id: license.id,
          displayName: license.displayName || license.id,
        })
      }
    })
  })

  return Array.from(licenseMap.values()).sort((a, b) => a.displayName.localeCompare(b.displayName))
}
